

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home'; 
import NFTDownload from './pages/NFTDownload';
import Hydrixpay from './pages/Hydrixpay';
import VirtualCard from './pages/VirtualCard';
import AutoPullPage from './pages/SetUpSubscribe';
import MyCard from './pages/MyCard';
import ValidatorApp from './pages/ValidatorApp';
import { AuthProvider } from './utils/AuthContext'
import { AuthProviderA, LoginPage, SignupPage, ProtectedRoute } from './components/Auth';



function App() {
  return (
    <Router>
      <AuthProvider apiUrl="https://chainfree.info:4000">
        <AuthProviderA>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nftdownload" element={<NFTDownload />} />
          <Route path="/hydrixpay" element={<Hydrixpay />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/validatorapp" element={<ValidatorApp />} />
          <Route 
            exact 
            path="virtualcard" 
            element={
              <ProtectedRoute>
                <VirtualCard />
              </ProtectedRoute>
            } 
          />
          <Route 
            exact 
            path="autoPullpage" 
            element={
              <ProtectedRoute>
                <AutoPullPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            exact 
            path="mycard" 
            element={
              <ProtectedRoute>
                <MyCard />
              </ProtectedRoute>
            } 
          />
        </Routes>
        </AuthProviderA>
      </AuthProvider>
    </Router>
  );
}

export default App;